import React from 'react';
import { Helmet } from 'react-helmet';

import { usePopmenuConfig } from '../../hooks/usePopmenuConfig';

type MetaProps = {
  canonicalPath: string
  description?: string | undefined
  imageHeight?: number | undefined
  imageUrl?: string | undefined
  imageWidth?: number | undefined
  title?: string | undefined
}

export const Meta = ({
  canonicalPath,
  description,
  imageHeight,
  imageUrl,
  imageWidth,
  title,
}: MetaProps) => {
  const { eatPopmenuUrl } = usePopmenuConfig();
  const canonicalUrl = `${eatPopmenuUrl}${canonicalPath}`;
  return (
    <Helmet
      title={title}
    >
      <link rel="canonical" href={canonicalUrl} />
      {description && (
        <meta name="description" content={description} />
      )}
      {imageUrl && (
        <meta property="og:image" content={imageUrl} />
      )}
      {imageHeight && (
        <meta property="og:image:height" content={String(imageHeight)} />
      )}
      {imageWidth && (
        <meta property="og:image:width" content={String(imageWidth)} />
      )}
    </Helmet>
  );
};
